import { Space, Table, Tag, Button } from 'antd'
import { Link, Router, Route } from 'react-router-dom'
import UserCheckModal from '../userCheckModal/userCheckModal.jsx'
import MessagePopOver from '../../../../components/popOver/popOver'
import './userTable.css'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { changeUserStatus, getUserList, userList } from '../../../../api/api'
import moment from 'moment'

const UserTable = forwardRef((props, ref) => {
  const columns = [
    {
      title: '用户编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '手机号码',
      dataIndex: 'phone',
      width: '15%',
      key: 'phone',
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: '用户性质',
      key: 'isMember',
      dataIndex: 'isMember',
    },
    {
      title: '发帖数量',
      key: 'threads',
      dataIndex: 'threads',
    },
    {
      title: '注册时间',
      key: 'createdAt',
      width: '20%',
      dataIndex: 'createdAt',
    },
    {
      title: '申请时间',
      key: 'appliedAt',
      width: '20%',
      dataIndex: 'appliedAt',
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Space size="middle">
            <UserCheckModal userDetail={record} setIsFresh={props.setIsfresh} />
          </Space>
        )
      },
    },
  ]

  // const pagination = props.pagination

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [loading, setLoading] = useState(false)
  const [userList, setUserList] = useState([])
  const [changeUsers, setChangeUsers] = useState([])
  const [userDetail, setUserDetail] = useState({})

  useImperativeHandle(ref, () => ({
    changeTable,
  }))

  const isMember = (num) => {
    switch (num) {
      case 1:
        return '会员'
        break
      case 0:
        return '非会员'
        break
      default:
        break
    }
  }
  //批量取消或者通过会员
  const changeUserState = (changeKey) => {
    // console.log(changeUsers);
    let arr = []
    changeUsers.map((info, index) => {
      return arr.push(info.id)
    })

    // console.log(arr);
    const params = {
      ids: arr,
      is_membership:changeKey,
    }
    changeUserStatus(params).then((res) => {
      console.log(res)
      props.setIsfresh((pre) => !pre)
    })
    setLoading(true)
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([])
      setLoading(false)
    }, 500)
  }
  const cancelmember = () => {
    changeUserState(0)
  }
  const pastmember = () => {
    changeUserState(1)
  }

  //当选择的内容变化的时候的回调
  const onSelectChange = (newSelectedRowKeys, record) => {
    // console.log("user change",record);
    setChangeUsers(record)
    //遍历一遍record
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }
  const hasSelected = selectedRowKeys.length > 0

  const changeTable = (data) => {
    data.map((cur, index) => {
      cur.key = index
      cur.isMember = isMember(cur.is_membership)
      cur.createdAt = moment(cur.created_at).format('YYYY-MM-DD HH:mm:ss')
      cur.appliedAt =cur.applied_at === null ? "-" : moment(cur.applied_at).format('YYYY-MM-DD HH:mm:ss')

      return cur
    })
    setUserList(data)
  }

  return (
    <div className="userManage">
      <div>
        <div
          style={{
            marginBottom: 16,
          }}
        >
          <div className="passUserButton">
            <Button
              onClick={cancelmember}
              disabled={!hasSelected}
              loading={loading}
            >
              批量取消会员
            </Button>
            <Button
              type="primary"
              onClick={pastmember}
              disabled={!hasSelected}
              loading={loading}
            >
              批量通过会员
            </Button>
            <span
              style={{
                marginLeft: 8,
              }}
            >
              {hasSelected ? `已选择 ${selectedRowKeys.length} 项` : ''}
            </span>
          </div>
        </div>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={userList}
          pagination={false}
          scroll={{
            y: 320,
            x: 1600,
          }}
          onRow={(record) => {
            return {
              onClick: (event) => {
                setUserDetail(record)
              }, // 点击行
              // onDoubleClick: event => {},
              // onContextMenu: event => {},
              // onMouseEnter: event => {}, // 鼠标移入行
              // onMouseLeave: event => {},
            }
          }}
        />
      </div>
    </div>
  )
})

export default UserTable
